import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Menu, X } from 'lucide-react';

import '../styles/Navigation.css';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Check if virtual race feature is enabled
  const isVirtualRaceEnabled = process.env.REACT_APP_VIRTUAL_RACE === 'true';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
        document.body.style.overflow = 'auto';
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const scrollToSection = (id) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Use setTimeout to ensure navigation completes before scrolling
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If we're already on home page, scroll immediately
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    closeMobileMenu();
  };

  return (
    <>
      <nav className={`nav-bar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src="/logo.png" alt="Logo" className="nav-logo-img" />
            Tó Túra
          </Link>

          <div className="menu-icon" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </div>

          <ul className={mobileMenuOpen ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}
                onClick={closeMobileMenu}
              >
                Főoldal
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/hogyan-mukodik" 
                className={location.pathname === '/hogyan-mukodik' ? 'nav-link active' : 'nav-link'}
                onClick={closeMobileMenu}
              >
                Hogyan működik
              </Link>
            </li>
            {isVirtualRaceEnabled && (
              <li className="nav-item">
                <Link 
                  to="/verseny" 
                  className={location.pathname === '/verseny' ? 'nav-link active' : 'nav-link'}
                  onClick={closeMobileMenu}
                >
                  Virtuális versenyek
                </Link>
              </li>
            )}
            <li className="nav-item">
              {isAuthenticated ? (
                <Link 
                  to="/profile" 
                  className={location.pathname === '/profile' ? 'nav-link active' : 'nav-link'}
                  onClick={closeMobileMenu}
                >
                  Fiókom
                </Link>
              ) : (
                <button 
                  className="nav-link"
                  onClick={() => loginWithRedirect()}
                >
                  Bejelentkezés
                </button>
              )}
            </li>
          </ul>
        </div>
      </nav>

      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={closeMobileMenu} 
      />

      <div className={`nav-menu-mobile ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
           <div className="mobile-menu-logo">
             <img src="/logo.png" alt="Logo" className="mobile-menu-logo-img" />
             Tó Túra
           </div>
           <button className="close-menu-button" onClick={closeMobileMenu} aria-label="Close menu">
             <X size={24} />
           </button>
        </div>
        <ul>
          <li className="nav-item">
            <Link to="/" className={location.pathname === '/' ? 'nav-link active' : 'nav-link'} onClick={closeMobileMenu}>Főoldal</Link>
          </li>
          <li className="nav-item">
            <Link to="/hogyan-mukodik" className={location.pathname === '/hogyan-mukodik' ? 'nav-link active' : 'nav-link'} onClick={closeMobileMenu}>Hogyan működik</Link>
          </li>
          {isVirtualRaceEnabled && (
            <li className="nav-item">
              <Link to="/verseny" className={location.pathname === '/verseny' ? 'nav-link active' : 'nav-link'} onClick={closeMobileMenu}>Virtuális versenyek</Link>
            </li>
          )}
          <li className="nav-item">
            {isAuthenticated ? (
              <Link to="/profile" className={location.pathname === '/profile' ? 'nav-link active' : 'nav-link'} onClick={closeMobileMenu}>Fiókom</Link>
            ) : (
              <button className="nav-link" onClick={() => loginWithRedirect()}>Bejelentkezés</button>
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navigation;